module.exports = __webpack_public_path__ + "assets/img/detail-btn-6b1b01c9.png";